<head>
  <meta charset="utf-8">
  <meta content="width=device-width, initial-scale=1.0" name="viewport">

  <title>SAION - Tecnología gubernamental</title>
  <meta content="" name="description">
  <meta content="" name="keywords">

  <!-- Favicons -->
  <link href="/assets/img/favicon.png" rel="icon">
  <link href="/assets/img/apple-touch-icon.png" rel="apple-touch-icon">

  <!-- Google Fonts -->
  <link href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Roboto:300,300i,400,400i,500,500i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i" rel="stylesheet">

  <!-- Vendor CSS Files -->
  <link href="/assets/vendor/animate.css/animate.min.css" rel="stylesheet">
  <link href="/assets/vendor/aos/aos.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap/css/bootstrap.min.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap-icons/bootstrap-icons.css" rel="stylesheet">
  <link href="/assets/vendor/boxicons/css/boxicons.min.css" rel="stylesheet">
  <link href="/assets/vendor/glightbox/css/glightbox.min.css" rel="stylesheet">
  <link href="/assets/vendor/remixicon/remixicon.css" rel="stylesheet">
  <link href="/assets/vendor/swiper/swiper-bundle.min.css" rel="stylesheet">

  <!-- Template Main CSS File -->
  <link href="/assets/css/style.css" rel="stylesheet">

  <!-- =======================================================
  * Template Name: Company - v4.7.0
  * Template URL: https://bootstrapmade.com/company-free-html-bootstrap-template/
  * Author: BootstrapMade.com
  * License: https://bootstrapmade.com/license/
  ======================================================== -->
</head>



<footer id="footer" style="background-color: #d68408;">





  <div class="footer-top" style="background-color: #ffffff;">
    <div class="container">
      <div class="row">




        <div class="col-lg-3 col-md-6 footer-contact">
          <h3 style="color: #d68408;">CONTACTO</h3>
          <p style="color: #d68408;">
            49750, Tolimán
            México <br><br>
            <strong style="color: #d68408;">Télefono:</strong><br>
            343 434 0128<br>

            <!-- <strong style="color: #d68408;"> Correo:</strong> presidencia@villapurificacion.gob.mx<br> -->

            <!-- <strong style="color: #d68408;"><a href="https://reporte.ciudadano.villapurificacion.gob.mx"> Sistema de Reportes</a> </strong> <br> -->


            <!-- <a style="font-weight: bold; color: #d68408;" href="admin/redes-sociales">Redes Sociales</a>

            <br>
              <label> Siguenos en:</label>

          <a style="color: #d68408;margin-left:1vh" href="{{this.facebook}}" target="_blank" class="facebook"><i
              class="bu bi-facebook"></i></a>
          <a style="color: #d68408;margin-left:1vh" href="{{this.youtube}}" target="_blank" class="youtube"><i
              class="bu bi-youtube"></i></a>
          </p> -->
        </div>


        <div class="col-lg-3 col-md-6 footer-links">



          <h5 style="color: #d68408;">Transparencia Nacional</h5>
                    <a href="https://www.plataformadetransparencia.org.mx"> <img height="100" width="200" style="border-radius: 2vh;"
                        src="https://i.imgur.com/kYLT2N2.png" alt=""> </a>

                        <h5 style="color: #d68408; margin-top: 2vh;">Infomex Jalisco</h5>
                    <a
                      href="https://www.infomexjalisco.org.mx">
                      <img height="100" width="200" style="border-radius: 2vh; margin-left: .5vh; " src="https://i.imgur.com/YtJjpWC.png" alt=""> </a>




                  </div>


                  <div class="col-lg-2 col-md-6 footer-links">



                    <h5 style="color: #d68408;">Actas de Nacimiento</h5>
                              <a href="https://www.gob.mx/ActaNacimiento/"> <img height="100" width="200" style="border-radius: 2vh;"
                                  src="https://i.imgur.com/9IOztGS.png" alt=""> </a>

                                  <h5 style="color: #d68408; margin-top: 2vh;">Curp</h5>
                              <a
                                href="https://www.gob.mx/curp/">
                                <img height="120" width="100" style=" margin-left: .5vh; " src="https://i.imgur.com/A4wGMwl.png" alt=""> </a>




                            </div>

                            <div class="col-lg-3 col-md-6 footer-links" style="margin-left: 5vh; margin-top: 5vh;">
                              <img style="width: 200px; height: 200px;" src="https://i.imgur.com/1QCHN80.png" alt="">

                             </div>

      </div>
    </div>
  </div>

  <div class="container d-md-flex py-4">

    <div class="me-md-auto text-center text-md-start">
      <div class="copyright">
        &copy; TOLIMAN

       <strong><span>  GOBIERNO MUNICIPAL 2024 - 2027</span></strong>   © Copyright toliman.gob.mx
      </div>

    </div>

  </div>








</footer><!-- End Footer -->
  <!-- <script async src="https://cdn.now4real.com/now4real.js"></script> -->
